import React, { useState, useRef, useEffect } from "react";
import { Category } from "../../../types/category";
import Accordion from "../../../components/Accordion";

const CategorySelect: React.FC<{
	category: Category;
	selected: string[];
	handleChange: (id: string) => void;
	handleCategorySelect: (chapterIds: string[], checked: boolean) => void;
}> = ({ category, selected, handleChange, handleCategorySelect }) => {
	const [open, setOpen] = useState(false);
	const chapterIds = (category.chapters || []).map((chapter) => chapter.id);
	const allSelected = chapterIds.length > 0 && chapterIds.every((id) => selected.includes(id));
	const someSelected = chapterIds.some((id) => selected.includes(id));
	const selectAllRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (selectAllRef.current) {
			selectAllRef.current.indeterminate = someSelected && !allSelected;
		}
	}, [someSelected, allSelected]);

	return (
		<div className="category-card">
			<div
				className="category-header"
				style={{ cursor: "pointer" }}
				onClick={(e) => (chapterIds.length > 1 ? setOpen((prev) => !prev) : handleCategorySelect(chapterIds, !allSelected))}>
				<input
					type="checkbox"
					ref={selectAllRef}
					checked={allSelected}
					onChange={(e) => handleCategorySelect(chapterIds, e.target.checked)}
					className="chapter-checkbox"
					onClick={(e) => {
						e.stopPropagation();
					}}
				/>
				<strong className="category-title">{category.category}</strong>
				{chapterIds.length > 1 && (
					<span
						style={{
							marginLeft: "auto",
							transition: "transform 0.2s",
							transform: open ? "rotate(90deg)" : "rotate(0deg)",
							display: "inline-block",
						}}>
						<i className="fa-solid fa-angle-right"></i>
					</span>
				)}
			</div>
			{/* Accordion animation */}
			{category.chapters && category.chapters.length > 1 && (
				<Accordion open={open}>
					<div className={"chapter-list"}>
						{category.chapters.map((chapter) => (
							<div
								key={chapter.id}
								className="chapter-item">
								<label className="chapter-checkbox-label">
									<input
										type="checkbox"
										checked={selected.includes(chapter.id)}
										onChange={() => handleChange(chapter.id)}
										className="chapter-checkbox"
									/>
									<span>{chapter.title}</span>
								</label>
							</div>
						))}
					</div>
				</Accordion>
			)}
			{category.chapters && category.chapters.length === 0 && (
				<div className="chapter-list">
					<div className="no-chapters">沒有可用的章節</div>
				</div>
			)}
		</div>
	);
};

export default CategorySelect;
